import "../layouts/default";
import { addRules } from "Components/form/validate-methods";

$(function () {
    $(".js-form-lost-password").validate({
        submitHandler: function (form) {
            form.submit();
        },
    });

    setTimeout(() => {
        for (const formElem of document.querySelectorAll(".js-form-reg-b2c")) {
            addRules(formElem, ["addressInputs"]);
        }

        for (const formElem of document.querySelectorAll(".js-form-reg-b2b")) {
            addRules(formElem, ["addressInputs"]);
        }
    }, 250);
});
$(document).on("change", '.js-invoice-checkbox input[type="checkbox"]', function () {
    const isChecked = $(this).is(":checked");
    const emailWrapper = $(this).closest("form").find(".js-invoice-email-wrapper");
    const emailInput = $(this).closest("form").find(".js-invoice-email");

    if (isChecked) {
        emailWrapper.hide();
        emailInput.removeAttr("required");
    } else {
        emailWrapper.show();
        emailInput.attr("required", "required");
    }
});

// Trigger change on load to set initial visibility
$('.js-invoice-checkbox input[type="checkbox"]').trigger("change");

const assignHiddenFields = (autocompleteField, data) => {
    const form = autocompleteField.closest("form");
    const billing = form.querySelector(".js-b2b-reg-billing");

    if (billing) {
        billing.classList.remove("h-nodisplay");

        if (Object.values(data.result || []).length) {
            for (const input of billing.querySelectorAll("input, select")) {
                $(input).valid();
            }
        }
    }
};

rEvent.on("Finstat.select.after", (autocompleteField, data) => {
    assignHiddenFields(autocompleteField, data);
});
